<template>
  <!-- 질문41 -->
  <v-layout flex-fill column class="survey-type-07">
    <div class="subheader">가능한 한 빠르게, 생각나는 대로 답변해 주세요. </div>
    <div class="question">문장의 빈칸을 완성해 주세요.</div>
    <div class="answer">
      <div class="answer-text answer-text-start">
        <div class="text">{{ surveyData.startQues }}</div>
      </div>
      <ResizeTextArea :reply="value" @inputChanged="inputChanged"/>
      <div class="answer-text answer-text-end">
        <div class="text">{{ surveyData.finishWord }}</div>
      </div>
    </div>
  </v-layout>
</template>

<script>
import store from '@/store'
import {mixinAuth} from '@/mixins'
import ResizeTextArea from '@/components/forms/ResizeTextArea'

export default {
  components: {
    ResizeTextArea,
  },
  mixins: [mixinAuth],
  props: ["question", "surveyData", "travelApplStepCd", "memberStepApplCnt"],
  data: () => ({
    value: ''
  }),
  created() {
    this.getStepLoadData();
  },
  methods: {
    inputChanged(input) {
      this.value = input;
      this.$emit('emotionSelected', input);
    },
    async getStepLoadData() { // 스텝별 저장 데이터를 가져옴.
      console.log('Step 07 - getStepLoadData Call');
      await store.dispatch('getStepLoadData', this.$_payload('so', [
        {'travelApplNo': this.surveyData.travelApplNo},
        {'unitNo': this.surveyData.unitNo},
        {'unitDtlNo': this.surveyData.unitDtlNo},
        {'unitDtlQuesNo': this.surveyData.unitDtlQuesNo},
        {'memberNo': this.userKey},
        {'travelApplStepCd': this.travelApplStepCd},
        {'memberStepApplCnt': this.memberStepApplCnt}
      ]))
        .then(res => {
          if (res.success) {
            this.value = res.data.reply;
            this.inputChanged(res.data.reply);
          } else {
            console.log(res.msg)
            this.value = '';
          }
        })
        .catch(error => {
          console.error(error)
          this.value = '';
        })
        .finally(() => {
        })
    },
  }
}
</script>
